import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@ts/components/PrefetchRoute';
import Logotype from '@ts/ui/Logotype';
//import AuthButton from '@ts/components/Authentication/AuthButton';
import { ReactComponent as Explore } from '@ts/images/icons/icon-explore.svg';
import { ReactComponent as History } from '@ts/images/icons/icon-history.svg';
import { ReactComponent as Cart } from '@ts/images/icons/icon-shopping_cart.svg';
import { ReactComponent as Favorite } from '@ts/images/icons/icon-favorite.svg';
import { ReactComponent as Satellite } from '@ts/images/icons/icon-satellite.svg';
import { ReactComponent as LibraryBooks } from '@ts/images/icons/icon-library_books.svg';
import { ReactComponent as ChatBubble } from '@ts/images/icons/icon-chat_bubble_outline.svg';
import { ReactComponent as Call } from '@ts/images/icons/icon-call.svg';
import { ReactComponent as Help } from '@ts/images/icons/icon-help_outline.svg';
import { get } from '@ts/utils/cs';
import * as S from './styles';

const Navigation = ({ navigationIsOpen, closeNavigation, countCartItems, openTalkToUs }) => {
    const [existRecentlyViewed, setExistRecentlyViewed] = React.useState(null);
    React.useEffect(() => {
        try {
            const json = get('Recently_Viewed');
            setExistRecentlyViewed(Array.isArray(json));
        } catch (err) {
            console.error(err);
        }
    }, [navigationIsOpen]);
    return (
        <>
            <S.BackgroundLock navigationIsOpen={navigationIsOpen} onClick={closeNavigation} />
            <S.NavigationWrapper navigationIsOpen={navigationIsOpen}>
                <S.Navigation>
                    <S.Content>
                        <S.Wrapper>
                            <Link to={'/'} onClick={closeNavigation}>
                                <Logotype textColor={'#000'} />
                            </Link>
                            <S.CloseButton onClick={closeNavigation} />
                        </S.Wrapper>
                        {/* <S.TheInscriptionBeforebutton>
                            Sign up or Login for Exclusive Rewards
                        </S.TheInscriptionBeforebutton>
                        <AuthButton>Sign up / Login</AuthButton> */}
                        <S.Line />
                        <S.List onClick={closeNavigation}>
                            <S.listItem to={'/destination/'}>
                                <S.Icon>
                                    <Explore />
                                </S.Icon>
                                <S.ItemName>Explore</S.ItemName>
                            </S.listItem>
                            {existRecentlyViewed && (
                                <S.listItem to={'/'}>
                                    <S.Icon>
                                        <History />
                                    </S.Icon>
                                    <S.ItemName>Recently Viewed</S.ItemName>
                                </S.listItem>
                            )}
                            {countCartItems > 0 && (
                                <S.listItem
                                    to={'/cart/'}
                                    onClick={(e) => {
                                        if (countCartItems === 0) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    <S.Icon>
                                        <Cart />
                                    </S.Icon>
                                    <S.ItemName>Shopping Cart</S.ItemName>
                                    <S.numberOfItemsInTheBasket>
                                        {countCartItems}
                                    </S.numberOfItemsInTheBasket>
                                </S.listItem>
                            )}
                            <S.listItem to={'/wishlist/'}>
                                <S.Icon>
                                    <Favorite />
                                </S.Icon>
                                <S.ItemName>Wish List</S.ItemName>
                            </S.listItem>
                            <S.listItem to={'/traveler-stories/'}>
                                <S.Icon>
                                    <Satellite />
                                </S.Icon>
                                <S.ItemName>Traveler Stories</S.ItemName>
                            </S.listItem>
                            <S.listItem to={'/blog/'}>
                                <S.Icon>
                                    <LibraryBooks />
                                </S.Icon>
                                <S.ItemName>Blog</S.ItemName>
                            </S.listItem>
                        </S.List>
                        <S.BoldGreyText>LOCAL SUPPORT</S.BoldGreyText>
                        <S.Line />
                        <S.List onClick={closeNavigation}>
                            <S.listItemRegularLink
                                onClick={(evt) => {
                                    evt.preventDefault();
                                    window.LiveChatWidget &&
                                        typeof window.LiveChatWidget.call === 'function' &&
                                        window.LiveChatWidget.call('maximize');
                                    document.querySelector('#chat-widget').style.display = 'block';
                                }}
                            >
                                <S.Icon>
                                    <ChatBubble />
                                </S.Icon>
                                <S.ItemName>Chat with us</S.ItemName>
                            </S.listItemRegularLink>
                            <S.listItemRegularLink onClick={openTalkToUs}>
                                <S.Icon>
                                    <Call />
                                </S.Icon>
                                <S.ItemName>Talk to us</S.ItemName>
                            </S.listItemRegularLink>
                            <S.listItem to={'/customer-service-guide/'}>
                                <S.Icon>
                                    <Help />
                                </S.Icon>
                                <S.ItemName>Help</S.ItemName>
                            </S.listItem>
                        </S.List>
                    </S.Content>
                    <S.Footer>
                        <a
                            href={'https://partners.tripshock.com/tour-operators/'}
                            onClick={closeNavigation}
                        >
                            List your tour
                        </a>
                    </S.Footer>
                </S.Navigation>
            </S.NavigationWrapper>
        </>
    );
};

Navigation.propTypes = {
    navigationIsOpen: PropTypes.bool,
    closeNavigation: PropTypes.func,
    countCartItems: PropTypes.number,
};

export default Navigation;
